import { Components, Theme } from '@mui/material'

export const MuiCardHeader: Components<Omit<Theme, 'components'>>['MuiCardHeader'] = {
  defaultProps: {
    style: {
      paddingTop: 16,
      paddingBottom: 16,
      paddingLeft: 24,
      paddingRight: 24,
    },
  },
}
